// icons
import { AccountBalanceWalletOutlined } from '@mui/icons-material';

// ==============================|| MENU ITEMS - FINANCE ||============================== //

const finance = {
  id: 'group-finance',
  title: 'Cost Management',
  type: 'group',
  roles: ['SUPER_ADMIN'], // Only visible to SUPER_ADMIN
  children: [
    {
      id: 'finance-overview',
      title: 'Overview',
      type: 'item',
      url: '/finance/overview',
      icon: AccountBalanceWalletOutlined,
      breadcrumbs: true
    },
    {
      id: 'finance-transactions',
      title: 'Transactions',
      type: 'item',
      url: '/finance/transactions',
      icon: AccountBalanceWalletOutlined,
      breadcrumbs: true
    },
    {
      id: 'finance-categories',
      title: 'Categories',
      type: 'item',
      url: '/finance/categories',
      icon: AccountBalanceWalletOutlined,
      breadcrumbs: true
    },
    {
      id: 'finance-cost-centres',
      title: 'Cost Centres',
      type: 'item',
      url: '/finance/cost-centres',
      icon: AccountBalanceWalletOutlined,
      breadcrumbs: true
    },
    {
      id: 'finance-reports',
      title: 'Reports',
      type: 'item',
      url: '/finance/reports',
      icon: AccountBalanceWalletOutlined,
      breadcrumbs: true
    }
  ]
};

export default finance;
